import { Link as RouterLink } from 'react-router-dom';
// material
import { Box, Link, Container, styled } from '@mui/material';
// layouts
import Page from 'components/Page';
import Iconify from 'components/Iconify';
import { ConfirmationCodeForm } from 'sections/authentication/confirmationCode';
import AuthLayout from 'layouts/AuthLayout';
// components

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function ConfirmationCode() {
  return (
    <RootStyle title="Confirmation Code | Aquatic monitoring system">
      <AuthLayout />

      <Container>
        <ContentStyle>
          <Box sx={{ mb: 2 }}>
            <Link variant="string" underline="none" component={RouterLink} to="/forgotPassword">
              <Iconify icon="eva:arrow-ios-back-fill" />
              Back
            </Link>
          </Box>
          <ConfirmationCodeForm navigateTo="/resetPassword" topic="Please check your email!" />
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
